/*
  FlavourArt: kostenlose Samples (Variante "Sample - 100 ml", SKU FA<code>-Samples).
  Weiche Grenze im Warenkorb: hoechstens 1 Sample je Artikel und 15 Samples je Bestellung.
  Laeuft nach jedem Aufruf von /cart/add, /cart/update und /cart/change sowie beim Laden der Seite.
*/
(function () {
  var MAX_SAMPLES = 15;
  var origFetch = window.fetch.bind(window);
  var busy = false, again = false;

  function isSample(item) {
    return /-samples?$/i.test(item.sku || '') || /sample/i.test(item.variant_title || '');
  }

  function toast(text) {
    var el = document.getElementById('fa-sample-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'fa-sample-toast';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;' +
        'max-width:calc(100% - 32px);background:#0A1A30;color:#fff;padding:12px 18px;border-radius:6px;' +
        'font-size:14px;line-height:1.4;box-shadow:0 4px 16px rgba(0,0,0,.25);';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.style.display = 'block';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.display = 'none'; }, 6000);
  }

  async function enforce() {
    if (busy) { again = true; return; }
    busy = true;
    again = false;
    try {
      var cart = await (await origFetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      // cart.js listet die neuesten Positionen zuerst - die aeltesten Samples behalten
      var samples = cart.items.filter(isSample).reverse();
      var updates = {}, changed = false, seen = {}, count = 0;
      samples.forEach(function (it) {
        var want = 1;
        if (seen[it.product_id] || count >= MAX_SAMPLES) want = 0;
        if (want === 1) { seen[it.product_id] = true; count++; }
        if (it.quantity !== want) { updates[it.key] = want; changed = true; }
      });
      if (!changed) return;
      await origFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      toast('Kostenlose Samples: höchstens 1 je Artikel und ' + MAX_SAMPLES +
            ' je Bestellung. Ihr Warenkorb wurde angepasst.');
      if (/^\/cart/.test(location.pathname)) {
        setTimeout(function () { location.reload(); }, 1500);
      } else if (typeof window.facSyncFromCart === 'function') {
        window.facSyncFromCart();
      }
    } catch (e) {
    } finally {
      busy = false;
      if (again) setTimeout(enforce, 50);
    }
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/(add|update|change)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { setTimeout(enforce, 50); }, function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enforce);
  else enforce();
})();
